import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created");
      navigate("/");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="container-pl py-16 lg:py-20" data-testid="register-page">
      <div className="max-w-md mx-auto">
        <p className="overline mb-5">Create your client account</p>
        <h1 className="display-serif text-4xl sm:text-5xl text-zinc-50 mb-3 leading-tight">
          Get started.
        </h1>
        <p className="text-sm text-zinc-400 mb-10 leading-relaxed">
          Sign up with your own email and password. After your intake, your portal will show
          case progress, documents, and appointment history.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="name">Full name</Label>
            <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} className="rounded-sm mt-1.5" data-testid="register-name" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm mt-1.5" data-testid="register-email" />
          </div>
          <div>
            <Label htmlFor="password">Password (min 6 chars)</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-sm mt-1.5" data-testid="register-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-sm bg-blue-700 hover:bg-blue-600 h-11" data-testid="register-submit">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Create Account
          </Button>
        </form>

        <p className="text-sm text-zinc-400 mt-6 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-amber-400 link-underline" data-testid="login-link">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
